// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusUprightOutlinedSvg from "@fishx/icons-svg/es/asn/RadiusUprightOutlined";
import FishxIcon from '../components/FishxIcon';

var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUprightOutlinedSvg
  }));
};

RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
export default React.forwardRef(RadiusUprightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadiusUprightOutlined.js
// module id = 3972
// module chunks = 0